var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 9.1665H4.16683C3.70659 9.1665 3.3335 9.5396 3.3335 9.99984C3.3335 10.4601 3.70659 10.8332 4.16683 10.8332H15.8335C16.2937 10.8332 16.6668 10.4601 16.6668 9.99984C16.6668 9.5396 16.2937 9.1665 15.8335 9.1665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinus);
export default __webpack_public_path__ + "static/media/ic_minus.f49c5f5bc6752fd4e6de9879e99313e2.svg";
export { ForwardRef as ReactComponent };